export type CopiedReference = {
  id: string;
  identifier: string;
  name: string;
  typename: string;
};

let copiedReference: CopiedReference | null = null;

export function setCopiedReference(ref: CopiedReference) {
  copiedReference = ref;
}

export function consumeCopiedReference(): CopiedReference | null {
  const ref = copiedReference;
  copiedReference = null;
  return ref;
}
